import { useTransferirTipoObraDialog } from "./use-transferir-tipo-obra-dialog";
import { TransferirTipoObraDialogView } from "./view-transferir-tipo-obra-dialog";
import type { TransferirTipoObraDialogProps } from "./types-transferir-tipo-obra-dialog";

export function TransferirTipoObraDialog(props: TransferirTipoObraDialogProps) {
  const vm = useTransferirTipoObraDialog(props);

  return <TransferirTipoObraDialogView {...vm} />;
}

export type * from "./types-transferir-tipo-obra-dialog";
